var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDropDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "arrow-drop-down_svg__a",
  width: 14,
  height: 8,
  x: 5,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m5.578 10.979 5.05 4.512c.76.679 1.989.679 2.749 0l5.05-4.512C19.655 9.88 18.777 8 17.042 8h-10.1C5.209 8 4.35 9.881 5.579 10.979"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#arrow-drop-down_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
}))));
export default SvgArrowDropDown;